/* eslint-disable max-lines */
import * as React from 'react';
import { ArmchairIcon } from '@fronton/icons-react';
import { MOSCOW, ST_PETERSBURG } from 'common/constants/region-codes';
import { DesignIcon } from './components/design-icon';
import { KITCHEN_CDN_PATH } from '../kitchen-constants';
import { ComplexCardStructure } from './components';

const TEN_DAYS_DELIVERY = {
  title: 'До 10 дней',
  text: 'готовая кухня',
}

const SEVEN_DAYS_DELIVERY = {
  title: 'До 7 дней',
  text: 'готовая кухня',
}

const FAST_DELEVIRY_REGIONS = [ST_PETERSBURG, MOSCOW];

export const getUtpCards = (regionId: string) => {
  const delivery = FAST_DELEVIRY_REGIONS.includes(regionId) ? SEVEN_DAYS_DELIVERY : TEN_DAYS_DELIVERY;

  return [
    {
      title: 'Бесплатное',
      text: 'проектирование за 1 час',
    },
    { ...delivery },
    {
      title: 'Услуги',
      text: 'доставки и установки',
    },
    {
      title: '25 лет',
      text: 'гарантии',
    },
  ]
};

export const getStageBlockData = (regionId: string) => ({
  title: `Готовая кухня за ${FAST_DELEVIRY_REGIONS.includes(regionId) ? '7' : '10'} дней`,
  cards: [{
    title: 'Дизайн и\u00A0смета',
    text: 'Создадим бесплатный проект и\u00A0подготовим смету',
    label: '1 день',
    btn: {
      label: 'Записаться',
      href: `/zapis-onlayn/?department_no=15&region_id=${regionId}`,
      title: 'Запись на бесплатное проектирование кухни',
    }
  },
  {
    title: 'Точный замер',
    text: 'Сделаем подробную схему комнаты, учтём все коммуникации',
    label: '2 дня',
    btn: {
      label: 'Записаться',
      href: '/uslugi/checkout/?categoryId=1832&measure=true',
      title: 'Оформление заказа',
    }
  },
  {
    title: 'Доставка и\u00A0сборка',
    text: 'Бережно привезём и\u00A0установим кухню, подключим технику',
    label: `до ${FAST_DELEVIRY_REGIONS.includes(regionId) ? '4' : '7'} дней`,
  }]
});

export const ADVICES = [
  {
    image: `${KITCHEN_CDN_PATH}/advices/1.jpg/1.jpg`,
    title: 'Как сделать кухню уютнее с помощью света',
    href: '/journal/kakoj-svet-nuzhen-na-kuhne/',
    topic: {
      icon: <ArmchairIcon type='outline' size='xs' color='secondary-purple-primary' />,
      name: 'Обустраиваю',
    },
    info: {
      date: '10.12.2025',
      type: 'text',
      duration: '7 мин.',
    },
  },
  {
    image: `${KITCHEN_CDN_PATH}/advices/2.jpg/2.jpg`,
    title: 'Замер помещение по кухню',
    href: '/journal/kak-organizovat-khraneniye-na-kukhne/',
    topic: {
      icon: <DesignIcon />,
      name: 'Планирую',
    },
    info: {
      date: '10.12.2025',
      type: 'text',
      duration: '6 мин.',
    },
  },
  {
    image: `${KITCHEN_CDN_PATH}/advices/3.jpg/3.jpg`,
    title: 'Неочевидные способы сделать ремонт на кухне и не разориться',
    href: '/journal/kak-vybrat-posudu/ ',
    topic: {
      icon: <ArmchairIcon type='outline' size='xs' color='secondary-purple-primary' />,
      name: 'Обустраиваю',
    },
    info: {
      date: '10.12.2025',
      type: 'text',
      duration: '8 мин.',
    },
  },
];

export const RELATED_PRODUCTS = [
  {
    title: 'Столовые приборы',
    href: '/catalogue/posuda-dlya-servirovki/',
    image: `${KITCHEN_CDN_PATH}/related-products/1.jpg/01.jpg`,
    videoSrc: 'https://cdn.lemanapro.ru/lmru/image/upload/v1783426882/fudzi/mf-landings-web/video/kitchen/related-products-1.MOV/related-products-1.MOV',
  },
  {
    title: 'Бытовая техника',
    href: '/catalogue/bytovaya-tehnika-dlya-kuhni/',
    image: `${KITCHEN_CDN_PATH}/related-products/2.jpg/02.jpg`,
    videoSrc: 'https://cdn.lemanapro.ru/lmru/image/upload/v1783426882/fudzi/mf-landings-web/video/kitchen/related-products-2.MOV/related-products-2.MOV',
  },
  {
    title: 'Кухонные аксессуары',
    href: '/catalogue/organizaciya-hraneniya-na-kuhne/',
    image: `${KITCHEN_CDN_PATH}/related-products/3.jpg/03.jpg`,
  },
];

export const BRANDS = [
  {
    name: 'Midea',
    image: {
      srcLd: `${KITCHEN_CDN_PATH}/brands/midea-ld.jpg/midea.jpg`,
      srcM: `${KITCHEN_CDN_PATH}/brands/midea-m.jpg/midea.jpg`,
    },
  },
  {
    name: 'Hotpoint',
    image: {
      srcLd: `${KITCHEN_CDN_PATH}/brands/hotpoint-ld.jpg/hotpoint.jpg`,
      srcM: `${KITCHEN_CDN_PATH}/brands/hotpoint-m.jpg/hotpoint.jpg`,
    },
  },
  {
    name: 'Haier',
    image: {
      srcLd: `${KITCHEN_CDN_PATH}/brands/haier-ld.jpg/haier.jpg`,
      srcM: `${KITCHEN_CDN_PATH}/brands/haier-m.jpg/haier.jpg`,
    },
  },
  {
    name: 'Maunfeld',
    image: {
      srcLd: `${KITCHEN_CDN_PATH}/brands/maunfeld-ld.jpg/maunfeld.jpg`,
      srcM: `${KITCHEN_CDN_PATH}/brands/maunfeld-m.jpg/maunfeld.jpg`,
    },
  },
];

export const MEDIA_BLOCK_TOP = [
  {
    title: 'Пятна — не проблема',
    text: 'Фасады не боятся кофе, масла и других загрязнений',
    image: `${KITCHEN_CDN_PATH}/media-block/top/1-ld.jpg/01.jpg`,
  },
  {
    title: 'Тестируем фурнитуру на прочность',
    text: 'Все петли рассчитаны на 60 000 открываний, а ящики\nи подъёмные механизмы — на 30 000 использований',
    image: `${KITCHEN_CDN_PATH}/media-block/top/2-ld.jpg/02.jpg`,
  },
  {
    title: 'Время не оставит следов',
    text: 'Кварцевые мойки устойчивы к термическим ударам,\nцарапинам и бытовым загрязнителям',
    image: `${KITCHEN_CDN_PATH}/media-block/top/3-ld.jpg/03.jpg`,
  },
];

export const MEDIA_BLOCK_MIDDLE = [
  {
    title: 'Техника для жизни',
    text: 'Поможем подобрать — у нас\nбольшой выбор брендов',
    image: `${KITCHEN_CDN_PATH}/media-block/middle/1-ld.jpg/3-ld.jpg`,
    videoSrc: 'https://cdn.lemanapro.ru/lmru/image/upload/video/fudzi/mf-landings-web%252Fvideo%252Fmedia-card-1.mov/media-card-1.mov',
  },
  {
    title: 'Умные механизмы',
    text: 'Всё открывается легко и без лишних усилий —\nпроверили ровно тысячу раз',
    image: `${KITCHEN_CDN_PATH}/media-block/middle/2-ld.jpg/3-ld.jpg`,
    videoSrc: 'https://cdn.lemanapro.ru/lmru/image/upload/v1783541804/fudzi/mf-landings-web/video/kitchen/IMG_0595.MOV/IMG_0595.MOV',
  },
  {
    title: 'Полный порядок',
    text: 'Удобные аксессуары для хранения, чтобы\nу каждой тарелки было своё место',
    image: `${KITCHEN_CDN_PATH}/media-block/middle/3-ld.jpg/3-ld.jpg`,
    videoSrc: 'https://cdn.lemanapro.ru/lmru/image/upload/video/fudzi/mf-landings-web%252Fvideo%252Fkitchen%252FIMG_0597%2B3.mov/IMG_0597 3.mov',
  },
];

export const MEDIA_BLOCK_BOTTOM = [
  {
    title: 'Столешницы и стеновые панели HPL',
    text: 'Прочные и практичные — не боятся солнца, влаги и очень\nпросты в уходе',
    image: `${KITCHEN_CDN_PATH}/media-block/bottom/1-ld.jpg/01.jpg`,
  },
  {
    title: 'Столешницы и панели из ДСП',
    text: 'Материал простой в уходе и надёжный в быту — не выгорает и\u00A0не\u00A0боится повседневной готовки',
    image: `${KITCHEN_CDN_PATH}/media-block/bottom/2-ld.jpg/02.jpg`,
  },
  {
    title: 'Столешницы из искусственного камня',
    text: 'Прочные и эффектные, толщиной 2 см',
    image: `${KITCHEN_CDN_PATH}/media-block/bottom/3-ld.jpg/03.jpg`,
  },
  {
    title: 'Столешницы из массива',
    text: 'Натуральное дерево прочное и надёжное в быту, а ещё устойчиво\nк влаге и резким перепадам температур',
    image: `${KITCHEN_CDN_PATH}/media-block/bottom/4-ld.jpg/04.jpg`,
  },
];

export const THREE_COMPLEX_CARDS: ComplexCardStructure[] = [
  {
    alt: 'Изображение фасада',
    srcLd: `${KITCHEN_CDN_PATH}/complex-cards/top/1-ld.jpg/1-ld.jpg`,
    srcT: `${KITCHEN_CDN_PATH}/complex-cards/top/1-t.jpg/1-t.jpg`,
    src: `${KITCHEN_CDN_PATH}/complex-cards/top/1-m.jpg/1-m.jpg`,
    title: 'Фасады и корпуса выдерживают нагрев до 70°C',
  },
  {
    alt: 'С заботой о лесе',
    srcLd: `${KITCHEN_CDN_PATH}/complex-cards/top/2-ld.jpg/02-ld.jpg`,
    srcT: `${KITCHEN_CDN_PATH}/complex-cards/top/2-t.jpg/02-t.jpg`,
    src: `${KITCHEN_CDN_PATH}/complex-cards/top/2-m.jpg/02-m.jpg`,
    title: 'С заботой о лесе',
  },
  {
    alt: 'Изображение фасадов',
    srcLd: `${KITCHEN_CDN_PATH}/complex-cards/top/3-ld.jpg/3-ld.jpg`,
    srcT: `${KITCHEN_CDN_PATH}/complex-cards/top/3-t.jpg/3-t.jpg`,
    src: `${KITCHEN_CDN_PATH}/complex-cards/top/3-m.jpg/3-m.jpg`,
    title: 'Улучшаем качество',
  },
];

export const TWO_COMPLEX_CARDS: ComplexCardStructure[] = [
  {
    alt: 'Изображение столешницы',
    srcLd: `${KITCHEN_CDN_PATH}/complex-cards/bottom/1-ld.jpg/1-ld.jpg`,
    srcT: `${KITCHEN_CDN_PATH}/complex-cards/bottom/1-t.jpg/1-t.jpg`,
    src: `${KITCHEN_CDN_PATH}/complex-cards/bottom/1-m.jpg/1-m.jpg`,
    title: 'Всё в одном стиле',
  },
  {
    alt: 'Изображение цветовых фактур',
    srcLd: `${KITCHEN_CDN_PATH}/complex-cards/bottom/2-ld.jpg/ld.jpg`,
    srcT: `${KITCHEN_CDN_PATH}/complex-cards/bottom/2-t.jpg/2-t.jpg`,
    src: `${KITCHEN_CDN_PATH}/complex-cards/bottom/2-m.jpg/2-m.jpg`,
    title: 'Много цветов и фактур',
  }
];
